import thunk from 'redux-thunk'
import RootReducer from './RootReducer'
import { configureStore } from '@reduxjs/toolkit'

export default configureStore({
    reducer: RootReducer,
    middleware: [thunk]
})